module.exports = __webpack_public_path__ + "static/Image16@2x-04acbfab15961b713073f93845fdce23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/photos/Image16@2x.jpg
// module id = 909
// module chunks = 227233210825294 244429959259914